import { Model } from '@vuex-orm/core'

export default class ItemModel extends Model {
  static entity = 'faqs'

  static nameSingular = 'FAQ'
  static namePlural = 'FAQs'

  static fields() {
    return {
      id: this.uid(),
      topic: this.string(''),
      question: this.string(''),
      answer: this.string('', (desc) =>
        desc !== 'null' ? desc : ''
      ).nullable(),
    }
  }

  static index_table_config() {
    return {
      dense: true,
    }
  }

  static fetch() {
    return this.api().get(`/faqs`)
  }
}
